import React, { memo } from "react";
import "./UniversalTextarea.scss";

const UniversalTextarea = memo(
  ({
    label,
    id,
    name,
    type,
    placeholder,
    onChange,
    value,
    required,
  }) => {
    const handleChange = (e) => {
      if (name) {
        onChange?.(e.target.value, name);
      } else {
        onChange?.(e.target.value);
      }
    };

    return (
      <div className="universal-textarea">
        <label
          className="universal-textarea__label"
          htmlFor={id}
        >
          {label}
        </label>

        <textarea
          className="universal-textarea__textarea"
          type={type}
          name={name}
          id={id}
          placeholder={placeholder}
          onChange={handleChange}
          value={value}
          required={required}
        />
      </div>
    );
  }
);

export default UniversalTextarea;
